import React from 'react';
import { Link } from 'react-router-dom';

const ChiefHome = () => (
  <div className="chief-hero">
    <p className="chief-hero-eyebrow">// AI-powered business intelligence</p>
    <h1>Your business, answered<br />in <em>plain English.</em></h1>
    <p>
      Ask anything about revenue, ad spend, or operations.
      Get a crisp, data-backed answer in seconds — sourced from Meta Ads, Shopify, and beyond.
    </p>
    <div className="chief-hero-ctas">
      <Link to="/login"  className="btn-gold">Get Started →</Link>
      <Link to="/signup" className="btn-ghost">Create account</Link>
    </div>
  </div>
);

export default ChiefHome;
